<template>
    <card-seplag titulo="Pendentes de Validação" cor="#00acc1" >        
        <DataTable :value="dadosTabelaPendentes" :paginator="true" :rows="10" responsiveLayout="scroll" class="p-datatable-responsive table-seplag"  style="width:100%">
            <Column field="matricula" header="Matrícula" :headerStyle="`width: 3%;`"></Column>
            <Column field="nome" header="Nome"></Column>
            <Column field="setor" header="Setor"></Column>
            <Column header="Período de Aquisitivo" headerStyle="width: 14em"  bodyStyle="text-align: center;">
                <template #body="slotProps">
                    {{slotProps.data.dataInicioDireitoAfastamento? slotProps.data.dataInicioDireitoAfastamento+" à "+slotProps.data.dataFimDireitoAfastamento : ""}}
                    {{slotProps.data.dataInicioPeriodoAquisitivo?slotProps.data.dataInicioPeriodoAquisitivo+" à "+slotProps.data.dataFimPeriodoAquisitivo: ""}}
                </template>
            </Column>
            <Column  headerStyle="width: 14em" bodyStyle="text-align: center" header="Período de Usufruto">
                <template  #body="slotProps"> 
                        <span>{{slotProps.data.dataInicio}} à {{slotProps.data.dataFim}}</span><br>                   
                        <span v-if="slotProps.data.dataInicioTemporario">Alterado para {{slotProps.data.dataInicioTemporario}} à {{slotProps.data.dataFimTemporario}}</span>
                    </template>
            </Column>
            <Column  headerStyle="width: 10em; text-align: center" header="Dias de Afastamento">
                <template #body="slotProps"> 
                    <div style="text-align: center;">
                        <span>{{slotProps.data.totalDias? slotProps.data.totalDias: slotProps.data.dias? slotProps.data.dias: "" }} dias <br></span>                       
                        <span v-if="slotProps.data.tipoJornada=='REDUZIDA'">(<b>Redução de Jornada</b>)</span>
                        <span v-if="slotProps.data.tipoJornada=='INTEGRAL'">(<b>Usufruto</b>)</span><br>
                        <span><b>{{slotProps.data.tipo? slotProps.data.tipo: slotProps.data.title? slotProps.data.title.toUpperCase() : ""}}</b></span>
                    </div>
                </template>
            </Column>
            <Column headerStyle="width: 9em" bodyStyle="text-align: center" header="Status">
                    <template #body="slotProps">                        
                            <span v-if="!slotProps.data.conflito"  class="customer-badge-aguardando">Aguardando</span>                        
                            <span v-else class="customer-badge-conflito">Conflito</span>
                    </template>
            </Column>
                    
            <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação">
                
                <template #body="slotProps">                        
                        <Button type="button" icon="pi pi-id-card" v-tooltip.top="'Aprovação'" @click="showModal(slotProps.data)" :disabled="slotProps.data.situacao=='ENCERRADO'" />
                </template>
            </Column>                 
        </DataTable>     
        
        <cadastro-rapido tituloTela="Aprovação" v-model="exibirTela" :modoEdicao="modoEdicao"  :onAdicionar="validaRegistro" :onfecharModal="fecharModalValidaEscala" optionValue="code" :textoButton="'Salvar'">
            <div class="p-col-12">
                <Fieldset >
                    <template #legend>
                        <strong>Servidor</strong>
                    </template>
                    <p><strong>Matricula: </strong> {{dadosAprovacao.matricula?dadosAprovacao.matricula : ""}}</p>
                    <p><strong>Candidato: </strong> {{dadosAprovacao.nome?dadosAprovacao.nome : ""}}</p>
                    <p><strong>Periodo de Usufruto: </strong> {{dadosAprovacao.dataInicio?dadosAprovacao.dataInicio : ""}} à {{dadosAprovacao.dataFim?dadosAprovacao.dataFim : ""}} </p>
                    <p v-if="dadosAprovacao.dataInicioTemporario"><strong>Alterado para </strong>{{dadosAprovacao.dataInicioTemporario}} à {{dadosAprovacao.dataFimTemporario}}</p>
                </Fieldset>
            </div>
            <Rotulo nome="Deferido" cols="12" >
                <SelectButton name='deferido' v-model="registro.statusProgramacao" :options="simNao" optionLabel="name"  v-required />
            </Rotulo>
            <Rotulo nome="Justificativa" cols="12" >
                <Textarea v-model="registro.observacaoTemporaria"  rows="5" cols="30" />
            </Rotulo>
        </cadastro-rapido>
    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import CadastroRapido from '@/template/CadRapidoSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { simNao } from '@/config/global'
import { baseApiUrl } from '@/config/global'

const getDefaultState = () => {
    return {  
        chave:null,
        idReg:null,
        dataInicio:null,
        dataFim:null,
        qtdDiasAfastamento:null,
        matricula:null,
        numeroVinculo:null,
        observacaoTemporaria:"",
        matriculaAprovador:null,
        numeroVinculoAprovador: null,
        statusProgramacao:{ name: "Não", code: "N" }
    }
}

export default {
    name:"feriasChefiaPendenteValidacao",
    components: { CardSeplag, CadastroRapido, Rotulo },    
    data: function(){
        return {        
            exibirTela: false,
            apiUrlRecurso: "feriasview",
            urlPaginacao: null,
            totalRegistro: 0,
            tamanhoPorpagina: 1000,
            paginacaoTabela: '?size=10&page=0',
            dadosTabelaPendentes: [],
            dadosAprovacao: [],
            simNao: simNao,
            registro: getDefaultState(),
            modoEdicao: 'adicionar',  
            habilitaAgendamento: true,   
        }
    },
    methods: {        
		carregarDados(){            
            this.urlPaginacao = `${this.apiUrlRecurso}/chefia/lista/PENDENTE/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}`
            this.$http.get(`${baseApiUrl}/${this.urlPaginacao}?size=${this.tamanhoPorpagina}&page=0`).then(res => {
               this.dadosTabelaPendentes = res.data.content
               this.totalRegistro = res.data.totalElements
               this.$http.get(`${baseApiUrl}/programacaoafastamentos/chefia/pendentes/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}/${this.$store.getters.getIdenPessoa}?size=${this.tamanhoPorpagina}&page=0`).then(res2 => {
                    if(res2.data.totalElements >0 ){
                        for(var i=0; i < res2.data.content.length;i++ ){
                            this.dadosTabelaPendentes.push(res2.data.content[i])
                        }
                        this.totalRegistro = this.totalRegistro + res.data.totalElements
                    }
                })

            })
        },
        showModal(dados){

            this.registro.observacaoTemporaria = ""
            this.registro.chave = dados.chave
            this.registro.idReg = dados.idReg
            this.registro.dataInicio = dados.dataInicio
            this.registro.dataFim = dados.dataFim
            this.registro.qtdDiasAfastamento = dados.totalDias
            this.registro.matricula = dados.matricula
            this.registro.numeroVinculo = dados.numeroVinculo
            this.dadosAprovacao = dados
            this.exibirTela = true
        },
        validaRegistro(){            
            if(this.registro.statusProgramacao.code  == "N" && this.registro.observacaoTemporaria.trim() == ""){
                    this.$toast.add({severity:'error', summary: "A justificativa é OBRIGATORIA quando o pedido de Férias for negado", life: 3000})
                    return
            }
            if(this.dadosAprovacao.tipoAfastamento==2){
                let registroLP = {                    
                    direitoAfastamento: {
                        idenDireitoAfastamento: this.dadosAprovacao.idenDireitoAfastamento
                    },
                    descJustificativa: this.registro.observacaoTemporaria,
                    numrMatriculaChefe: this.$store.getters.getMatricula,
                    numrVinculoChefe:  this.$store.getters.getVinculo,
                    statusProgramacao: {
                        idenStatusProgramacao: {name: 'Sim', code: "S"}
                    }
                }
                if(this.registro.statusProgramacao.code == "S"){
                    registroLP.statusProgramacao.idenStatusProgramacao = 2 // aprovado
                }else{
                    registroLP.statusProgramacao.idenStatusProgramacao = 3 // reprovado               
                }

                this.$http.put(`${baseApiUrl}/programacaoafastamentos/validacao/${this.dadosAprovacao.idenProgramacaoAfastamento}/${this.$store.getters.getUser.dadosUsuariosCustomizados.matricula}/${this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap.vinculo}`,JSON.stringify(registroLP)).then(() => {
                    if(this.registro.statusProgramacao.idenStatusProgramacao == 2){
                        this.$toast.add({severity:'success', summary: 'Agendamento aprovado com Sucesso! Informações encaminhadas por email', life: 3000})
                    }
                    this.carregarDados()
                    this.exibirTela =   false
                })

            }else{                     
                let situacao = ''
                if(this.registro.statusProgramacao.code == "S"){
                    situacao = 'APROVADO'
                }else{
                    situacao = 'REPROVADO'        
                }           
                let jsonBody = {
                ...this.registro,
                matriculaAprovador: this.$store.getters.getMatricula,
                numeroVinculoAprovador: this.$store.getters.getVinculo,
                }
                this.$http.put(`${baseApiUrl}/feriasview/chefia/acao/${situacao}`,JSON.stringify(jsonBody)).then(() => {
                    if(this.registro.statusProgramacao.code == "S"){
                        this.$toast.add({severity:'success', summary: 'Agendamento aprovado com Sucesso! Informações encaminhadas por email', life: 3000})
                    }
                    this.carregarDados()
                    this.exibirTela =   false
                })
            }

        },
        fecharModalValidaEscala(){            
            this.exibirTela = false
        }

    },
    mounted(){
		// Carrega os dados do serviço
		this.carregarDados()
    }

}
</script>

<style>
.customer-badge-aguardando {
    border-radius: 2px;
    padding: .25em .5em;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    background-color: #C8E6C9;
    color: #256029;
}
.customer-badge-conflito {
    border-radius: 2px;
    padding: .25em .5em;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    background-color: #FFCDD2;
    color: #C63737;
}

</style>